// extracted by mini-css-extract-plugin
export var deleteIcon = "_m2-5";
export var deleteOption = "_m2-3";
export var divider = "_m2-2";
export var downloadIcon = "_m2-4";
export var drawer = "_m2-0";
export var drawerFooter = "_m2-6";
export var drawerOpen = "_m2-1";
export var highlighted = "_m2-7";
export var lighterHighlight = "_m2-8";